import ApiError from "../../errors/ApiError";

export class UnlinkCustomerIcneaError extends ApiError {
  constructor() {
    super("Failed to unlink customer from Icnea");
  }
}
